import React, { useEffect, useState } from "react";
import { Button, Card, Modal, ModalBody, Table } from "reactstrap";
import { getGroupSlotById } from "../store/actions/favoriteAction";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";

const ViewGroupChatParticipantModal = (props) => {
  let [loader, setLoader] = useState(true);

  let dispatch = useDispatch();
  let { groupSlotById } = useSelector((state) => state.favorite);

  useEffect(() => {
    if (props.slotId !== "") {
      setLoader(true);
      dispatch(
        getGroupSlotById(props.slotId, () => {
          setLoader(false);
        })
      );
    }
  }, [props.slotId]);

  const handelClose = () => {
    props.handelViewBookingGroupModal();
  };
  return (
    <Modal
      isOpen={props.ShowViewBookingGroupModal}
      toggle={props.handelViewBookingGroupModal}
      size="xl"
      top="true"
      backdrop="static"
      keyboard={false}
    >
      <ModalBody>
        <Card className="p-2">
          {loader ? (
            <div className="spinner-border text-primary loader mx-auto my-4"></div>
          ) : (
            <Table className="table align-items-center mt-2" responsive>
              <thead>
                <tr>
                  <th scope="col" className="custom-table-heading">
                    Fan Name
                  </th>
                  <th scope="col" className="custom-table-heading">
                    Fan Email
                  </th>
                  <th scope="col" className="custom-table-heading">
                    Payment Date
                  </th>
                  <th scope="col" className="custom-table-heading">
                    Paid Amount
                  </th>
                </tr>
              </thead>
              <tbody>
                {groupSlotById.length > 0 ? (
                  groupSlotById.map((items, index) => {
                    return (
                      <tr key={index}>
                        <td className="custom-table-text">{items.name}</td>
                        <td className="custom-table-text">{items.email}</td>
                        <td className="custom-table-text">
                          {moment
                            .unix(items.payments.payment_date.seconds)
                            .format("MMM-DD-YYYY")}
                        </td>
                        <td className="custom-table-text">
                          {items.paidAmount}$
                        </td>
                      </tr>
                    );
                  })
                ) : (
                  <tr>
                    <td className="custom-table-text">N/A</td>
                    <td className="custom-table-text">N/A</td>
                    <td className="custom-table-text">N/A</td>
                    <td className="custom-table-text">N/A</td>
                  </tr>
                )}
              </tbody>
            </Table>
          )}
        </Card>
        <div className="mt-3 d-flex justify-content-end">
          <Button color="primary" onClick={handelClose}>
            Close
          </Button>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default ViewGroupChatParticipantModal;
